import type { WebPageLDSchema } from "@gik/seo";
import organizationSDGenerator from "@gik/seo/structuredDataContentGenerators/organizationSDGenerator";

export interface WebPageSDGeneratorOptions {
	name: string;
	description: string;
	url: string;
}

export default function webPageSDGenerator(
	options: WebPageSDGeneratorOptions,
): WebPageLDSchema {
	if (!options) {
		return null;
	}

	return {
		"@type": "WebPage",
		name: options.name,
		description: options.description,
		url: options.url,
		publisher: organizationSDGenerator(),
	};
}
